import { Styles } from 'shared/types';

export const ListboxContainer: Styles = {
  height: '324px',
};

export const PeopleListHeader: Styles = {
  marginTop: '8px',
};
